export const engagementSegmentsCampaignsForLinkSegmentation =
  "/engagement/segments/campaigns_for_link_segmentation";
